var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.msg)?_c('div',{staticClass:"quotes-card"},[_c('img',{staticClass:"quotes-icon start",attrs:{"src":require("@/assets/images/icp/quotes_left.webp")}}),_c('img',{staticClass:"quotes-icon end",attrs:{"src":require("@/assets/images/icp/quotes_right.webp")}}),_c('div',{staticClass:"card-msg"},[_vm._v(_vm._s(_vm.msg))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }